<template xmlns="http://www.w3.org/1999/html">
  <div style="width: 100vw;height: 100vh;">

    <!--开始防伪结果页面 -->
    <div id="background" v-if="showAntiResult" style="width: 100vw;
    position:fixed;
    background: url(/static/images/ainiu/bg.png) no-repeat;
    background-attachment:fixed;
    background-size:cover;
    height: 100vh;
    overflow: hidden;display: flex;flex-direction: column;align-items: center;">


      <img src="/static/images/ainiu/edu.png" style="width: 70vw;z-index: 1;margin-top: 13vh;" />

      <div v-if="showResult" style="width: 90vw;height: 40vh;position: relative;background-color: white;border-radius: 10px;z-index: 2;
    display: flex;flex-direction: column;align-items: center;justify-content: center;">
        <img src="/static/images/ainiu/rule.png" @click="openPopup"
          style="position: absolute;width: 20vw;right: 5vw;top:4vw;z-index: 1;" />

        <span style="font-size: 5vw;font-weight:400;margin-top: 1vh;">{{ antiCode }}</span>
        <div style="width: 100%;display: flex;justify-content: center;text-align: center;margin-top: 4vh;">
          <div style="font-size: 5vw;font-weight: 400;width: 75%;">{{ antiMessage }}</div>
        </div>
      </div>

      <div v-if="!antiFail && showResult" @click="joinActivity"
        style="width: 85%;height: 45px;background-color: rgb(55,125, 217);margin-top: 4vh;font-size: 4.5vw;border-radius: 6px;text-align: center;color: white;display: flex;justify-content: center;align-items: center;z-index: 2;">
        参与活动</div>

      <wx-open-launch-weapp v-if="showJfButton && showResult" id="launch-btn"
        style="z-index: 2;position: relative;width: 100vw;height: 9.5vh;" :appid="miniAppId"
        :username="miniAppOriginalId" :path="miniAppPage">
        <script type="text/wxtag-template">
        <div 
        style="width: 80vw !important;margin-left:10vw !important;height: 45px;background-color: rgb(55,125, 217);margin-top: 30px;font-size: 4.5vw;border-radius: 6px;text-align: center;color: white;display: flex;justify-content: center;align-items: center;">
        前往商城兑换</div></script>
      </wx-open-launch-weapp>

      <img src="/static/images/ainiu/bottom.png" style="width: 100vw;position: absolute;bottom: 0;z-index: 1;" />

    </div>
    <!--结束防伪结果页面-->


    <!--输入信息开始-->
    <div id="background" v-if="showInfo" style="width: 100vw;
    position:fixed;
    background: url(/static/images/ainiu/bg3.png) no-repeat;
    background-attachment:fixed;
    background-size:cover;
    height: 100vh;
    overflow: hidden;display: flex;flex-direction: column;align-items: center;">


      <img src="/static/images/ainiu/ainiulogo.png" style="width: 30vw;z-index: 1;margin-top: 12vh;" />
      <img src="/static/images/ainiu/zhuanzhu.png" style="width: 55vw;z-index: 1;margin-top: 5vh;" />

      <div class="input-container">
        <div class="input-item">
          <img src="/static/images/ainiu/user.png" style="width: 20px;height: 24px;margin-right: 8px;">
          <input type="text" class="input-field" v-model="name" placeholder="输入用户名" @input="fullflag">
        </div>
        <div class="input-item">
          <img src="/static/images/ainiu/phone.png" style="width: 20px;height: 24px;margin-right: 8px;">
          <input type="text" class="input-field" v-model="mobile" placeholder="输入手机号" @input="fullflag">
        </div>
      </div>

      <div @click="fullInfo" v-if="full"
        style="width: 80%;height: 45px;background-color: rgb(55,125, 217);margin-top: 20vh;font-size: 16px;border-radius: 6px;text-align: center;color: white;display: flex;justify-content: center;align-items: center;">
        登录</div>
      <div v-if="!full"
        style="width: 80%;height: 45px;background-color: rgb(220,222, 228);margin-top: 20vh;font-size: 16px;border-radius: 6px;text-align: center;color: white;display: flex;justify-content: center;align-items: center;">
        登录</div>
      <div style="width: 80%;font-size: 11px;color: gray;margin-top: 10px;">
        登录即代表您已阅读并同意<span style="color: rgb(74, 143, 222);" @click="openXy">《用户协议》</span>与<span
          style="color: rgb(74, 143, 222);" @click="openYs">《隐私政策》</span>
      </div>




    </div>
    <!--输入信息结束-->



    <!--获取积分弹框开始 -->
    <div id="background" style="z-index: 4;" v-if="showJf">
      <div id="jfwin" class="modalwin" @click="closePopupWin()"></div>
      <div
        style="position: relative;display:flex;text-align: center;justify-content: center;align-items: center;width: 100vw;">
        <img src="/static/images/ainiu/sanguang.png"
          style="position:absolute;width: 100vw;z-index: 5;bottom: 13vh;left: 0;" />
        <div
          style="position:absolute;width: 80vw;z-index: 6;bottom: 35vh;right: 5.5vw;display: flex;flex-direction: column;">
          <img src="/static/images/ainiu/win.png" style="width: 100%;" />
          <div
            style="width: 86%;position: absolute;font-size: 6.5vw;bottom: 24%;z-index: 7;font-style: italic;font-weight: bold;background: -webkit-linear-gradient(rgb(254,252,239), rgb(252,239,93));-webkit-background-clip: text;background-clip: text;color: transparent;">
            恭喜您获得{{ jfValue }}积分!
          </div>

          <div
            style="width: 86%;position: absolute;font-size: 4.5vw;bottom: 8%;text-align: center;display: flex;align-items: center;justify-content: center;z-index: 7;">
            <wx-open-launch-weapp id="launch-btn" :appid="miniAppId" :username="miniAppOriginalId" :path="miniAppPage">
              <script type="text/wxtag-template">
            <button style="color: rgb(75, 149, 247);border: 0;font-size:15px;border-radius: 15px;width: 150px;height:40px;z-index: 7;font-weight: bold;">前往商城兑换</button>
          </script>
            </wx-open-launch-weapp>
          </div>
        </div>

      </div>
      <img src="/static/images/ainiu/close.png" style="position:absolute;width: 8vw;left:46vw;bottom: 27vh;z-index: 6;"
        @click="closePopupWin()" />
    </div>
    <!--获取积分弹框结束-->


    <!--活动规则开始-->
    <div v-if="showPopup" style="z-index: 3;">
      <div id="activityRule" class="modal" @click="closePopup()"></div>
      <div class="modal-content">
        <img src="/static/images/ainiu/tipbanner.png"
          style="position: absolute;width: 100%;left: 0;top:0;z-index: 1;" />
        <div
          style="z-index: 2;width: 90%;position: absolute;position: absolute;left:5%;top: 9%;text-align: center;display: flex;flex-direction: column;align-items: center;">
          <span style="color: rgb(51, 51,51);font-size:6vw;margin-top: 5vh;">活动规则</span>
          <div
            style="width: 100%;text-align: left;font-size: 4vw;color: rgb(76,76,76);font-weight: 350;line-height: 2.5;margin-top: 15px;text-indent: -10;">
            <div style="display: flex;text-align: left;">
              <span style="margin-right: 3px;">1.</span>积分兑换码为购买爱牛科教产品所附赠福利;
            </div>
            <div style="display: flex;">
              <span style="margin-right: 3px;">2.</span>用户获得后点击参与活动可领取积分;
            </div>
            <div style="display: flex;">
              <span style="margin-right: 3px;">3.</span>活动积分只第一次有效，重复扫码无效;
            </div>
            <div style="display: flex;">
              <span style="margin-right: 3px;">4.</span>积分有效期截至当年12月31日，过期清零;
            </div>
            <div style="display: flex;">
              <span style="margin-right: 3px;">5.</span>最终解释权归爱牛科教所有。
            </div>
          </div>
        </div>
      </div>
      <img src="/static/images/ainiu/close.png" style="position: absolute;width: 8vw;left:46vw;top: 82vh;z-index: 4;"
        @click="closePopup()" />
    </div>
    <!--活动规则结束-->


    <!--用户协议开始-->
    <div v-if="showxy" style="z-index: 3;">
      <div id="activityRule" class="modal" @click="closeXy()"></div>
      <div class="modal-xy">

        <div
          style="z-index: 2;width: 90%;position: absolute;position: absolute;left:5%;top: 0%;text-align: center;display: flex;flex-direction: column;align-items: center;">
          <span style="color: rgb(51, 51,51);font-size:6vw;margin-top: 3vh;">用户协议</span>
          <div
            style="width: 100%;text-align: left;font-size: 3.5vw;color: rgb(76,76,76);font-weight: 350;line-height: 2.5;margin-top: 15px;text-indent: -10;">
            <div style="display: flex;flex-direction: column;text-align: left;">
              <div>
                <div style="text-align: left;">
                  尊敬的客户您好，欢迎您访问爱牛互动平台（以下简称:平台）。在您注册成为平台会员之前，请您务必认真阅读和理解《用户协议》（以下简称:协议）中所有的条款。您须完全同意协议中所有的条款，才可以注册成为本平台的会员，使用里面的服务。您在平台的注册和其他操作均将被视为是您对协议所有条款及内容的自愿接受。
                </div>
              </div>
              <div>
                在您注册成为平台用户前请务必仔细阅读本协议，特别是限制或免除责任的相应条款、法律适用和争议解决条款。本协议内容包括本协议正文与已发布的、将来可能发布的，以及经我们不时修订的各项规则。修订后的规则一经在平台公布立即生效，成为本协议的组成部分。我们有权在必要时修改本协议条款并在平台予以公示，您可以在平台相关服务页面查阅最新版本的协议条款。本协议条款变更后，如果您同意并继续使用我们提供的服务，即视为已接受修改后的协议。如果不接受修改后的协议，应当停止使用我们提供的服务并立即联系我们。
              </div>
              <div>会员注册方式</div>
              <div>可直接通过扫描防伪码参与营销活动，填写相关注册信息成为会员。</div>
              <div>礼品激励</div>
              <div>根据您参与的计划不同，您可以享受不一样的福利。具体请参见品牌方不时发布的活动。</div>
              <div>平台服务条款</div>
              <div>1.品牌方将不时根据自己的市场推广计划，调整礼品规则予以公布，调整礼品内容和市场推广活动内容。</div>
              <div>2.每个用户只能扫描一次包装上的二维码，获得一次礼品或活动机会。所有礼品和物品均给与用户，而不是个人，用户应承担商事主体应当承担的财务和法律责任，并按照税法要求缴纳相应的税费。</div>
              <div>3.品牌方根据公司自身需要，有权取消、终止、修改和暂停本活动。</div>
              <div>双方权利及义务</div>
              <div>
                1.品牌方在现有技术实现基础上努力维护平台的正常稳定运行，并努力提升和改进技术，对平台功能及服务进行更新、升级，以不断提升平台性能和效率。如发现用户有损系统安全、稳定的操作的，品牌方有权立即停止该用户的服务权限，并立即删除所有有害信息、数据等；用户应对此导致的一切不利后果承担全部法律责任。
              </div>
              <div>2.品牌方对用户在使用平台过程中遇到的问题及提出的建议和意见予以积极回复，可依用户需求对其使用平台提供合理的指导。</div>
              <div>
                3.用户同意品牌方将其在平台注册、进行浏览、参与抽奖等活动时，涉及的真实姓名/名称、联系电话等个人用户信息及商业信息使用在平台及其相关服务中，品牌方将对上述个人用户信息及商业信息予以严格保密，除非得到乙方的授权或法律另有规定，甲方不会向外界披露。
              </div>
              <div>
                4.用户有权依据本协议的约定查看并使用平台相应服务，用户应妥善保管其账户、密码等信息。在开通平台权限后，用户可以指定其员工代理进行操作。用户知悉并同意，其指定的人员是其代理人，受指定的人员在平台一切行为的法律后果由用户承担。
              </div>
              <div>5.用户保证遵守本协议，不从事任何有损品牌方和公共利益的行为，在使用平台的过程中遵守诚实信用原则，不扰乱平台的正常秩序。</div>
              <div>6.用户应确保在本平台上所登录之信息均为真实材料，如有虚假信息或冒用他人信息的，品牌方有权立即取消该用户在本平台的账号，且用户应承担因此造成的全部法律责任。</div>
              <div>7.用户不得通过任何第三方软件或人工形式对平台服务进行干扰，包括但不限于重复扫描、擅自变更后台数据或以其他不正当手段参加活动。如有发现，品牌方将立即终止服务，并取消该用户的账号。</div>
              <div>8.用户应保证在平台发布的信息合法、真实、准确、完整，符合平台规则及监管机构相关规定，不包含任何未经授权的文字和图片等信息，乙方发布信息的内容须严格遵守以下禁止事项：</div>
              <div>-禁止发布发表损害国家、民族、社会公共利益和涉及国家安全的信息资料或言论；</div>
              <div>-禁止利用平台从事洗钱、窃取商业秘密、窃取用户信息等违法犯罪活动；</div>
              <div>-禁止干扰平台的正常运转，不得侵入平台信息系统；</div>
              <div>-禁止发表任何违法犯罪、淫秽、不文明等信息资料；</div>
              <div>-禁止传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；</div>
              <div>-禁止利用在平台注册的账户进行非法牟利性经营活动；</div>
              <div>-禁止发布任何侵犯他人著作权、商标权等知识产权或合法权利的内容。</div>
              <div>9.乙方知悉并同意，乙方违反本协议时，乙方应立即向甲方承担法律责任（包括但不限于支付违约金、赔偿金、补足保证金差额等）。</div>
              <div>保密义务</div>
              <div>
                1.用户对于本协议的签订、内容及在履行本协议期间所获知的其他方的商业秘密负有保密义务。非经相对方书面同意，不得向相对方以外的任何第三方（关联公司除外）泄露、给予或转让该等保密信息。（根据法律法规、监管机构相关规定向政府、监管机构提供除外）。
              </div>
              <div>2.如相对方提出要求，任何一方均应将载有相对方单独所有的保密信息的任何文件、资料或软件等，在本协议终止后按对方要求归还对方，或予以销毁，或进行其他处置，并且不得继续使用这些保密信息。</div>
              <div>
                3.在本协议终止之后，各方在本条款项下的义务并不随之终止，各方仍需遵守本协议之保密条款，履行其所承诺的保密义务，直到其他方同意其解除此项义务，或事实上不会因违反本协议的保密条款而给其他方造成任何形式的损害时为止。
              </div>
              <div>4.任何一方均应告知并督促其因履行本协议之目的而必须获知本协议内容及因合作而获知对方商业秘密的雇员、代理人、顾问等遵守保密条款，并对其雇员、代理人、顾问等的行为承担责任。</div>
              <div>免责条款</div>
              <div>1.不论在何种情况下，品牌方均不对由于电力、网络、电脑、通讯或其他系统的故障、暴乱、骚乱、火灾、洪水、风暴、爆炸、战争、政府行为等不可抗力，造成的不能服务或延迟服务承担责任。</div>
              <div>2.用户自行承担那使用本平台产生的费用，包括但不限于上网费、手机流量费、短信费等费用。</div>
              <div>3.品牌方不承担用户因提交错误信息导致无法收到物品的情况。</div>
              <div>协议终止</div>
              <div>1.在以下情况下，品牌方有权停止服务并终止本协议：</div>
              <div>（1）用户注册信息中的主要内容不真实或不准确且拒绝更正；</div>
              <div>（2）用户主动向我们要求注销账户；</div>
              <div>（3）用户违反本协议的规定或违反相关法律、法规的。</div>
              <div>（4）品牌方根据自身需要关闭本平台，终止协议。</div>
              <div>合规</div>
              <div>
                用户在使用本平台时不得违反法律法规的规定，不得侵害任何第三方的合法权益。用户应严格遵守所有在中国适用的防止贿赂和反腐败的法律，不会向任何单位或个人直接或间接提供、允诺提供或授权提供任何贿赂、回扣、报酬或任何其他款项或礼物。
              </div>
              <div>用户应保持完整、真实的，能正确反映其业务活动的会计账簿和凭证，不得有任何秘密和或者未记录的资金、重复记账或其他类型的虚假陈述。</div>
              <div>
                用户在参与本计划期间，不得与品牌方员工进行任何商业投资、不得向品牌方员工赠送或接受其赠送的礼物、避免其员工及员工家属与品牌方的员工或员工家属有任何商业上的交往活动导致可能的利益冲突。用户还将帮助品牌方了解其员工与品牌方员工之间存在的商业交易或者其它关系的相关信息。
              </div>
              <div>法律适用和争议解决</div>
              <div>1.履行本协议过程中产生的任何争议，协议方应协商解决，协商不成的，任一方有权将争议提交上海国际经济贸易仲裁委员会按照该会仲裁规则进行仲裁。仲裁裁决是终局的，对双方均有约束力。</div>
              <div>2.本协议的签订、解释、变更、履行及争议的解决等均适用中华人民共和国法律。</div>
              <div>&nbsp;</div>
            </div>

          </div>
        </div>
      </div>
      <img src="/static/images/ainiu/close.png" style="position: absolute;width: 8vw;left:46vw;top: 90vh;z-index: 4;"
        @click="closeXy()" />
    </div>
    <!--用户协议结束-->



    <!--隐私政策开始-->
    <div v-if="showys" style="z-index: 3;">
      <div id="activityRule" class="modal" @click="closeYs()"></div>
      <div class="modal-xy">
        <div
          style="z-index: 2;width: 90%;position: absolute;position: absolute;left:5%;top: 0%;text-align: center;display: flex;flex-direction: column;align-items: center;">
          <span style="color: rgb(51, 51,51);font-size:6vw;margin-top: 3vh;">隐私政策</span>
          <div
            style="width: 100%;text-align: left;font-size: 3.5vw;color: rgb(76,76,76);font-weight: 350;line-height: 2.5;margin-top: 15px;text-indent: -10;">
            <div style="display: flex;text-align: left;flex-direction: column;">
              <div>尊敬的客户您好，欢迎您访问爱牛互动平台（以下简称:平台）。平台深知个人信息对您的重要性，我们将按照法律法规的规定，保护您的个人信息及隐私安全。我们制定本&ldquo;隐私政策&rdquo;并特别提示：
              </div>
              <div>希望您在使用相关服务前仔细阅读并理解本隐私政策，以便做出适当的选择。</div>
              <div>我们会遵循隐私政策收集、使用您的信息，但不会仅因您同意本隐私政策而采用强制捆绑的方式收集个人信息。</div>
              <div>
                当您使用或开启相关功能或使用服务时，为实现功能、服务所必需，我们会收集、使用相关信息。除非是为实现基本业务功能或根据法律法规要求所必需的必要信息，您均可以拒绝提供且不影响其他功能或服务。我们将在隐私政策中逐项说明哪些是必要信息。
              </div>
              <div>如果您未登录帐号，我们会通过设备对应的标识符信息来保障信息推送的基本功能。如果您登录了账号，我们会根据账号信息实现信息推送。</div>
              <div>
                通讯录、精确地理位置、摄像头、麦克风、相册权限，均不会默认开启，只有经过您的明示授权才会在为实现特定功能或服务时使用，您也可以撤回授权。特别需要指出的是，即使经过您的授权，我们获得了这些敏感权限，也不会在相关功能或服务不需要时而收集您的信息。
              </div>
              <div>本隐私政策适用于您通过我们网页或者小程序等方式使用我们的产品和服务。</div>
              <div>
                下文将帮您详细了解我们如何收集、使用、存储、传输、共享、转让（如适用）与保护个人信息。
              </div>
              <div>1.我们如何收集和使用个人信息</div>
              <div>我们会按照如下方式收集您在使用服务时主动提供的，以及通过自动化手段收集您在使用功能或接受服务过程中产生的信息：</div>
              <div>1.1注册、登录、认证</div>
              <div>1.1.1注册、登录</div>
              <div>
                a.当您注册、登录相关服务时，您可以通过手机号创建账号，并且您可以完善相关的网络身份识别信息（头像、昵称、密码），收集这些信息是为了帮助您完成注册。
              </div>
              <div>1.1.2认证</div>
              <div>
                在您使用身份认证的功能或服务时，根据相关法律法规，您可能需要提供您的真实身份信息（真实姓名、电话号码）以完成实名验证。这些信息属于个人敏感信息，您可以拒绝提供，但您将可能无法获得相关服务，但不影响其他功能与服务的正常使用。
              </div>
              <div>1.2浏览</div>
              <div>a.为了更好的参与平台营销活动，为实现这一功能，我们可能会收集必要的日志信息。</div>
              <div>b.用于信息展示的日志信息包括：</div>
              <div>您操作使用的行为信息：点击、关注、收藏、搜索、浏览、分享</div>
              <div>您主动提供的信息：反馈、发布、点赞、评论</div>
              <div>地理位置信息：GPS信息、WLAN接入点、蓝牙和基站等传感器信息</div>
              <div>c.GPS地理位置是敏感个人信息，若您拒绝提供，我们将不会根据GPS信息向您推荐信息，且不会影响其他功能的正常使用。</div>
              <div>d.我们会基于IP地址对应的城市向您展示、推荐您所在地区的本地相关信息。</div>
              <div>e.我们收集、使用的上述信息进行了去标识化处理，数据分析仅对应特定的、无法直接关联您身份的编码，不会与您的真实身份相关联。</div>
              <div>1.3收集、使用个人信息目的变更</div>
              <div>
                请您了解，随着我们业务的发展，可能会对功能和提供的服务有所调整变化。原则上，当新功能或服务与我们当前提供的功能或服务相关时，收集与使用的个人信息将与原处理目的具有直接或合理关联。在与原处理目的无直接或合理关联的场景下，我们收集、使用您的个人信息，会再次进行告知，并征得您的同意。
              </div>
              <div>1.4依法豁免征得同意收集和使用的个人信息</div>
              <div>请您理解，在下列情形中，根据法律法规及相关国家标准，我们收集和使用您的个人信息无需征得您的授权同意：</div>
              <div>a.与国家安全、国防安全直接相关的；</div>
              <div>b.与公共安全、公共卫生、重大公共利益直接相关的；</div>
              <div>c.与犯罪侦查、起诉、审判和判决执行等直接相关的；</div>
              <div>d.出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</div>
              <div>e.所收集的您的个人信息是您自行向社会公众公开的；</div>
              <p>&nbsp;</p>
            </div>
          </div>
        </div>
      </div>
      <img src="/static/images/ainiu/close.png" style="position: absolute;width: 8vw;left:46vw;top: 90vh;z-index: 4;"
        @click="closeYs()" />
    </div>
    <!--隐私政策结束-->
  </div>



</template>

<style scoped>
.input-container {
  margin-top: 12vh;
  display: flex;
  flex-direction: column;
  gap: 16px;
  /* 两个文本框之间的间距 */
}

.input-item {
  width: 80vw;
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 24px;
  padding: 10px 20px;
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
}


.input-field {
  border: none;
  outline: none;
  flex: 1;
  font-size: 16px;
}

.input-field::placeholder {
  color: #999;
}



.modal {
  position: fixed;
  /* 固定位置 */
  z-index: 3;
  /* 位于顶层 */
  left: 0;
  top: 0;
  width: 100vw;
  /* 宽度全屏 */
  height: 100vh;
  /* 高度全屏 */
  overflow: hidden;
  background-color: rgba(3, 3, 3, 0.6);
  /* 超出内容可滚动 */
}

.modalwin {
  position: relative;
  /* 固定位置 */
  z-index: 4;
  /* 位于顶层 */
  left: 0;
  top: 0;
  width: 100vw;
  /* 宽度全屏 */
  height: 100vh;
  /* 高度全屏 */
  overflow: hidden;
  background-color: rgba(3, 3, 3, 0.6);
  /* 超出内容可滚动 */
}



/* 模态内容 */
.modal-xy {
  overflow: auto;
  background-color: white;
  top: 8vh;
  left: 7vw;
  /* 上下自动，左右15% */
  padding: 25px;
  border: 0px;
  width: 86vw;
  height: 80vh;
  text-align: center;
  z-index: 3;
  border-radius: 20px;
  position: absolute;
}


/* 模态内容 */
.modal-content {
  overflow: auto;
  background-color: white;
  top: 25vh;
  left: 7vw;
  /* 上下自动，左右15% */
  padding: 25px;
  border: 0px;
  width: 86vw;
  height: 55vh;
  text-align: center;
  z-index: 3;
  border-radius: 20px;
  position: absolute;
}
</style>


<script>
import { getJSSDK, joinActivity, getAntiData, getScoreConfig, getTemplate, registerByOpenId, getWechatAuth, updateUserInfo } from '../../api/api'
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      antiCode: "",
      antiMessage: "",
      antiFail: false,
      showPopup: false,
      eno: "138666418426",
      showResult: false,
      deptId: "",
      shopUrl: "",
      miniAppId: "",
      miniAppOriginalId: "",
      miniAppPage: "",
      activityId: 0,
      authCode: "",
      showAntiResult: true,
      showInfo: false,
      name: "",
      showxy: false,
      showys: false,
      mobile: "",
      full: false,
      userToken: "",
      jfValue: 0,
      showJf: false,
      showJfButton: false,
    }
  },
  methods: {
    fullflag(event) {
      if (this.mobile != '' && this.name != '') {
        this.full = true
      } else {
        this.full = false
      }
    },
    async queryAnti() {
      var res = await getAntiData(this.antiCode, this.eno);
      const data = res.data;
      if (data == null || data.code == "500") {
        alert("防伪查询失败,请联系管理员");
      } else {
        //数码不存在的场景
        if (data.code == "300106") {
          this.antiFail = true
          this.antiMessage = "尊敬的顾客，您所查询的号码不存在！请您仔细核实，感谢您的查询!"
        }
        if (data.code == "300101" || data.code == "300102") {
          this.antiCode = data.data.code
          this.antiMessage = "尊敬的顾客，感谢您选购爱牛产品!您所查询的为爱牛赠品积分,请点击“参与活动”，输入信息，获得对应积分，感谢您的查询!"
          this.deptId = data.data.deptId
        }
        this.showResult = true
        if (this.authCode != null && this.authCode != '') {
          this.joinActivity()
        }
      }
    },
    getAuth() {
      const url = window.location.href.split('#')[0];
      getWechatAuth(url, "wxe9b46393a0cb8eed", 1).then(res => {
        const data = res.data;
        window.location.href = data;
      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    },
    async joinActivity() {
      await this.getScoreConfig()
      await this.getTemplate()

      if (this.activityId == 0 || this.activityId == "" || this.activityId == null || this.activityId == undefined) {
        alert("活动已结束")
      } else {
        //发起用户授权
        if (this.authCode == undefined || this.authCode == "" || this.authCode == null) {
          this.getAuth()
          return;
        }
        //用户注册
        const registerResult = await registerByOpenId(this.eno, this.authCode)
        if (registerResult.data.code == "500") {
          alert("用户登录异常，请联系管理员")
          return
        } else {
          this.userToken = registerResult.data.data.token
        }

        //用户是否填写了手机号信息
        if (registerResult.data.data.tel == null) {
          this.showAntiResult = false
          this.showInfo = true
          return
        }



        const data = {
          code: this.antiCode,
          activityId: this.activityId,
          authCode: this.authCode,
          userToken: this.userToken
        }

        const result = await joinActivity(data)
        if (result.data.code == "200") {
          this.jfValue = result.data.data.giftValue
          this.showAntiResult = true
          this.showInfo = false
          this.showJf = true
        } else if (result.data.code == "500001") {
          this.showAntiResult = true
          this.antiMessage = "尊敬的顾客，感谢您选购爱牛产品!您所查询的积分已领取，请进入商城兑换相应产品，感谢您的查询!"
          this.showInfo = false
          this.showJf = false
          this.antiFail = true
          this.showJfButton = true
        } else if (result.data.code == "500") {
          alert(result.data.message)
          this.showAntiResult = true
          this.showInfo = false
          this.showJf = false
        }

      }


    },
    async fullInfo() {
      if (this.name == "" || this.mobile == "") {
        alert("为了您能够正常获取积分，请正确填写姓名和手机号信息")
        return;
      }
      var updateData = {
        token: this.userToken,
        userName: this.name,
        tel: this.mobile
      }
      var res = await updateUserInfo(updateData);
      if (res.data.code == "200") {
        this.joinActivity();
      } else {
        alert("用户信息更新异常");
      }
    },
    async getScoreConfig() {
      const res = await getScoreConfig(this.deptId)
      if (res.data.data != null) {
        this.shopUrl = res.data.data.shopUrl
        const data = this.shopUrl.split('|')
        this.miniAppId = data[0]
        this.miniAppOriginalId = data[1]
        this.miniAppPage = data[2]
      }
    },
    async getTemplate() {
      const res = await getTemplate(this.deptId)
      if (res.data.data != null) {
        this.activityId = res.data.data.activityId
      }
    },
    closePopupWin() {
      this.showJf = false
    },
    closeYs() {
      this.showys = false
    },
    closeXy() {
      this.showxy = false
    },
    openYs() {
      this.showys = true
    },
    openXy() {
      this.showxy = true
    }
    ,
    openPopup() {
      this.showResult = false
      this.showPopup = true
    },
    closePopup() {
      this.showResult = true
      this.showPopup = false
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, "wxe9b46393a0cb8eed").then(res => {
        const data = res.data.data
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名，见附录1
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });

      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    }
  },
  mounted: function () {
    this.getWxJs()
  },
  created: function () {
    const params = this.$route.query;
    const code = params.c;
    const eno = params.eno;
    const authCode = this.$route.query.wyAuthCode
    //存储授权信息
    if (authCode != null && authCode != undefined) {
      this.authCode = authCode
    }

    //码信息
    if (code != null && code != undefined) {
      this.antiCode = code.substring(0, 16)
      //执行防伪查询代码
      this.queryAnti(code)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AiNiu/Index.vue